import React, { MouseEvent, ReactNode } from "react";

import { ToggleButtonGroup } from "@mui/material";
import { ToggleButtonGroupProps } from "@mui/material/ToggleButtonGroup/ToggleButtonGroup";

type IgToggleButtonGroupProps<V extends string = string> =
  ToggleButtonGroupProps & {
    control: {
      onChange: (event: MouseEvent<HTMLElement>, val: V) => void;
      exclusive?: boolean;
    };
    value: string;
    buttons: ReactNode[];
  };

export const IgToggleButtonGroup = ({
  buttons,
  control,
  value,
  ...props
}: IgToggleButtonGroupProps) => {
  const { sx, ...rest } = props;
  return (
    <ToggleButtonGroup {...control} {...rest} value={value} sx={sx}>
      {buttons}
    </ToggleButtonGroup>
  );
};
